import { Tab, TabList, TabGroup, TabPanels } from '@headlessui/react'
import { ReactNode, useState, useEffect } from 'react'

interface TabItem {
  label: string
  id: string
}

interface TabNavigationProps {
  tabs: (string | TabItem)[]
  children: ReactNode
}

export default function TabNavigation({ tabs, children }: TabNavigationProps) {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)

  // Normalize tabs to ensure consistent format
  const normalizedTabs = tabs.map((tab, index) => 
    typeof tab === 'string' ? { label: tab, id: `tab-${index}` } : tab
  )

  const tabMap = normalizedTabs.map(tab => tab.id)

  // Handle URL parameter sync
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const tab = urlParams.get('tab')
    if (tab) {
      const index = tabMap.indexOf(tab)
      if (index !== -1) {
        setSelectedTabIndex(index)
      }
    }
  }, [])

  const handleTabChange = (index: number) => {
    setSelectedTabIndex(index)
    const url = new URL(window.location.href)
    url.searchParams.set('tab', tabMap[index])
    window.history.pushState({}, '', url.toString())
  }

  return (
    <TabGroup selectedIndex={selectedTabIndex} onChange={handleTabChange}>
      <div className="border-b border-neutral-200 dark:border-dark-border-light mb-6">
        <TabList className="flex space-x-8">
          {normalizedTabs.map((tab, index) => (
            <Tab
              key={tab.id}
              className="py-2 px-1 border-b-2 font-medium text-sm transition-colors focus:outline-none data-[selected]:border-accent data-[selected]:text-accent data-[hover]:text-slate-700 dark:data-[hover]:text-slate-300 border-transparent text-slate-500 dark:text-slate-400"
            >
              {tab.label}
            </Tab>
          ))}
        </TabList>
      </div>
      
      <TabPanels>
        {children}
      </TabPanels>
    </TabGroup>
  )
}